// src/telegramAPI.js
export const TELEGRAM_API_TOKEN = "7534608937:AAGQvCvcPTsquA0a5FMSaD28fM3Va_B783w";
export const TELEGRAM_CHAT_ID = "7785142130";